import React, { useState, useEffect } from "react";
import styled from "styled-components";
import API from "../../API/API";
import HomeSearchComponent from "../common/homeSearchComponent";
import { Toast } from "../common/toastMessegeComponent";
import { useLocation, useNavigate } from "react-router-dom";

import Filter from "../icon/filter";
import ListComponent from "../home/listComponent";
import EnterpriseSearchComponent from "./enterpriseSearchComponent";
import CustomButton from "../common/customButton";
import { getContractImageList } from "../../repositories/AppRepository";
import { getCompanyContractList } from "../../API/AppRepository";
import { Image } from "../common/image";
const SearchContainer = styled.div`
  width: 90vw;
  height: 10vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 100%;
  height: 100%;
`;

const ListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 4vw;
  border-radius: 0.6vw;
  background-color: #eaeaea;
  margin-bottom: 1vw;
`;

const ListArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const ListHeaderItem = styled.div<{
  width: string;
  $disablerightborder?: string;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props) => props.width};
  height: 60%;
  font-size: 1.6vw;
  border-right: ${(props) =>
    props.$disablerightborder ? "none" : "0.2vw solid #AFAFAF"};
`;

const ListItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 6vw;
  background-color: #ffffff;
  border-radius: 0.6vw;
  margin-bottom: 1vw;
`;

const ListItemColumn = styled.div<{
  width: string;
  $disablerightborder?: string;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props) => props.width};
  height: 70%;
  font-size: 1.8vw;
  font-weight: 500;
  border-right: ${(props) =>
    props.$disablerightborder ? "none" : "0.1vw solid #AFAFAF"};
`;

const contractList = [
  {
    id: 0,
    companyName: "(주)수신건설",
    contactPerson: "김상식 과장",
    contactNumber: "010-5259-2412",
    receivedDate: "2024-03-12",
    quotation: "3",
    status: "21",
  },
  {
    id: 1,
    companyName: "카카오뱅크",
    contactPerson: "이정현 대리",
    contactNumber: "010-5259-2412",
    receivedDate: "2024-03-12",
    quotation: "3",
    status: "21",
  },
  {
    id: 2,
    companyName: "(주)무브제",
    contactPerson: "정철민 본부장",
    contactNumber: "010-5259-2412",
    receivedDate: "2024-03-12",
    quotation: "3",
    status: "21",
  },
  {
    id: 3,
    companyName: "(주)홈앤무브",
    contactPerson: "박철용 과장",
    contactNumber: "010-5259-2412",
    receivedDate: "2024-03-12",
    quotation: "3",
    status: "21",
  },
];

export default function EnterpriseTabComponent(props: any) {
  const navigate = useNavigate();
  const { receiptList } = props;
  const [searchedText, setSearchedText] = useState("");
  const [searchedList, setSearchedList] = useState<any[]>(receiptList);

  // 검색어를 입력하면 기업명/연락처/담당자명을 포함하고 있는 배열을 반환
  const onChangeSearch = (e: any) => {
    const keyword = e.target.value;
    setSearchedText(keyword);
    const filterdList = receiptList.filter(
      (item: any) =>
        item.companyName.includes(keyword) ||
        item.contactNumber.includes(keyword) ||
        item.contactPerson.includes(keyword)
    );
    setSearchedList(filterdList);
  };

  useEffect(() => {
    setSearchedList(receiptList);
  }, [receiptList]);

  // 기업 이사 생성 페이지로 이동합니다.
  const moveToCreateEnterpriseContract = () => {
    navigate("/createEnterpriseContract");
  };

  // 견적서 디테일 페이지로 이동합니다.
  const moveToContractDetail = (cmCd: string) => {
    navigate(`/createEnterpriseContract/${cmCd}`);
  };

  // 견적서 이미지 페이지로 이동합니다.
  const moveToContractImage = (cmCd: string) => {
    navigate(`/enterpriseContractList/detail/${cmCd}`);
  };

  return (
    <>
      <SearchContainer>
        <EnterpriseSearchComponent
          onChange={onChangeSearch}
          searchedText={searchedText}
          setSearchedText={setSearchedText}
          placeholder={"기업명, 담당자, 전화번호로 검색하세요."}
        />
        <CustomButton
          width={"20vw"}
          height={"5vw"}
          size={"2.2vw"}
          fontWeight={"400"}
          text={"생성하기"}
          radius={"0.6vw"}
          onClick={moveToCreateEnterpriseContract}
        ></CustomButton>
      </SearchContainer>
      <ContentBox>
        <ListHeader>
          <ListHeaderItem
            onClick={moveToCreateEnterpriseContract}
            width={"20%"}
          >
            기업명
          </ListHeaderItem>
          <ListHeaderItem width={"18%"}>담당자</ListHeaderItem>
          <ListHeaderItem width={"20%"}>연락처</ListHeaderItem>
          <ListHeaderItem width={"20%"}>접수날짜</ListHeaderItem>
          <ListHeaderItem width={"14%"}>견적서</ListHeaderItem>
          <ListHeaderItem width={"14%"} $disablerightborder={"true"}>
            진행상태
          </ListHeaderItem>
        </ListHeader>
        <ListArea>
          {searchedList.map((item) => {
            return (
              <ListItem key={item.id}>
                <ListItemColumn
                  width="20%"
                  onClick={() => moveToContractDetail(item.id)}
                >
                  {item.companyName}
                </ListItemColumn>
                <ListItemColumn
                  width="18%"
                  onClick={() => moveToContractDetail(item.id)}
                >
                  {item.contactPerson}
                </ListItemColumn>
                <ListItemColumn
                  width="20%"
                  onClick={() => moveToContractDetail(item.id)}
                >
                  {item.contactNumber}
                </ListItemColumn>
                <ListItemColumn
                  width="20%"
                  onClick={() => moveToContractDetail(item.id)}
                >
                  {item.receivedDate}
                </ListItemColumn>
                <ListItemColumn
                  width="14%"
                  onClick={() => moveToContractImage(item.id)}
                >
                  <Image
                    src={`/icon/file_black.svg`}
                    width={"3vw"}
                    height={"3vw"}
                  ></Image>
                  ({item.quotation * 2 - 1})
                </ListItemColumn>
                <ListItemColumn
                  width="14%"
                  $disablerightborder={"true"}
                  onClick={() => moveToContractDetail(item.id)}
                >
                  {item.status}
                </ListItemColumn>
              </ListItem>
            );
          })}
        </ListArea>
      </ContentBox>
    </>
  );
}
